<div class="testimonial -container" #testimonial>
  <div class="-testimonial-items">
    <ng-content></ng-content>
  </div>
</div>